/* Onixm — pont panier de la page onboarding.
   Réutilise la fenêtre d'ajout rapide du thème (cart-drawer-quickadd.js) :
   charge ses dépendances depuis le CDN du thème (même dossier que ce fichier,
   lui-même posé par asset_url dans le gabarit), préremplit le flocage et la
   quantité dans la fenêtre, puis pose le code de palier du site et ouvre le
   tiroir du panier sur l'accueil. Au repos, la page reste identique : rien
   de visible n'est ajouté au DOM. */
(function () {
  'use strict';
  if (!document.currentScript) return;
  const baseAssets = new URL('.', document.currentScript.src).href;

  /* Les données du parcours (MOI, TOP, VESTES) sont posées par le script de la page
     comme globaux lexicaux : lis() les lit sans planter si la page venait à changer. */
  const lis = (nom) => { try { return new Function('return ' + nom)(); } catch (e) { return undefined; } };
  const borene = (n) => Math.max(1, Math.min(4, n | 0));

  /* État : la fenêtre en cours (produit, quantité, éventuellement le maillot qui suit
     pour l'offre « Veste + maillot »), et le pont prêt ou non. */
  let etape = null;
  let pret = false;

  /* 1. Point de vérité de l'ajout : le quickadd envoie POST /cart/add.js et n'émet
     aucun événement — on écoute la réponse. Succès : on enchaîne l'étape suivante
     (veste puis maillot) ou on redirige vers /cart. Échec : le toast d'erreur du
     thème (OnixCart.showCartError) est déjà affiché par le quickadd ; on réarme. */
  const fetchReel = window.fetch;
  window.fetch = function (...args) {
    const promesse = fetchReel.apply(this, args);
    try {
      const entree = args[0];
      const url = String((entree && entree.url) || entree || '');
      const methode = String((args[1] && args[1].method) || (entree && entree.method) || 'GET').toUpperCase();
      if (methode === 'POST' && /\/cart\/add\.js/.test(url)) {
        promesse.then((res) => {
          try {
            if (res.ok) {
              if (etape && etape.suivant) { etape = etape.suivant; enchainne(etape.handle); }
              else { etape = null; posePalierPuisCart(); }
            } else {
              etape = null;
            }
          } catch (e) { /* ne jamais bloquer la réponse */ }
        });
      }
    } catch (e) { /* idem */ }
    return promesse;
  };

  /* 2. Chargement des dépendances du quickadd, dans son ordre prévu : utils puis quickadd
     (async=false = ordre d'insertion respecté), plus la feuille de style de la fenêtre. */
  const feuille = document.createElement('link');
  feuille.rel = 'stylesheet';
  feuille.href = baseAssets + 'cart-drawer-quickadd.css';
  document.head.appendChild(feuille);

  const utils = document.createElement('script');
  utils.src = baseAssets + 'cart-drawer-utils.js';
  utils.async = false;
  document.head.appendChild(utils);

  const quick = document.createElement('script');
  quick.src = baseAssets + 'cart-drawer-quickadd.js';
  quick.async = false;
  quick.addEventListener('load', () => { pret = true; }, { once: true });
  document.head.appendChild(quick);

  /* 3. La fenêtre est créée par le quickadd quand on clique sur [data-quick-add] —
     on y retrouve le produit du contexte courant et on y applique flocage + quantité. */
  const obs = new MutationObserver(() => {
    const fenetre = document.getElementById('onix-quick-add-popup');
    if (!fenetre) return;
    const ctx = etape;
    if (!ctx) return;
    const nom = (document.getElementById('nom') || {}).value || '';
    const num = (document.getElementById('numero') || {}).value || '';
    const champNom = fenetre.querySelector('[data-qa-flocage="Nom"]');
    const champNum = fenetre.querySelector('[data-qa-flocage="Numéro"]');
    if (champNom && nom.trim()) champNom.value = nom.trim();
    if (champNum && num.trim()) champNum.value = num.trim();
    const plus = fenetre.querySelector('[data-qa-qty-plus]');
    if (plus) for (let i = 1; i < ctx.qty; i++) plus.click();
  });
  obs.observe(document.body, { childList: true });

  /* 4. Les deux liens : on prévient la navigation et on pose le produit à ouvrir.
     Quickadd pas prêt ou données absentes : on ne prévient rien — le lien naturel
     (fiche produit) prend le relais, jamais un lien mort. */
  function brancheClics() {
    for (const idLien of ['lienVeste', 'lienFinal']) {
      const lien = document.getElementById(idLien);
      if (!lien) continue;
      lien.addEventListener('click', (e) => {
        if (!e.isTrusted || !pret) return;
        const ctx = contexte(idLien);
        if (!ctx) return;
        e.preventDefault();
        etape = ctx;
        lien.dataset.quickAdd = ctx.handle;
      });
    }
  }

  /* Le produit à ouvrir selon l'écran d'origine et les choix déjà faits dans la page. */
  function contexte(idLien) {
    const MOI = lis('MOI'), TOP = lis('TOP'), VESTES = lis('VESTES');
    if (!MOI || !TOP || !VESTES) return null;
    const maillot = TOP[MOI.club];
    const veste = VESTES[MOI.coloris];
    if (!maillot || !veste) return null;
    if (idLien === 'lienFinal') return { handle: maillot.h, qty: borene(MOI.n) };
    const btnOffre = document.querySelector('#offresVeste button.on');
    const offre = btnOffre ? +btnOffre.dataset.o : 1; /* défaut de la page : 2 vestes */
    if (offre === 3) return { handle: veste.h, qty: 1, suivant: { handle: maillot.h, qty: 1 } };
    return { handle: veste.h, qty: borene(offre + 1) };
  }

  /* Enchaînement « Veste + maillot » : la veste est au panier, on ouvre la fenêtre du maillot. */
  function enchainne(handle) {
    const lien = document.getElementById('lienVeste');
    if (!lien || !pret) { posePalierPuisCart(); return; }
    lien.dataset.quickAdd = handle;
    lien.click(); /* synthétique : isTrusted=false, notre écoute ne le reprend pas */
  }

  /* La remise du site, ce sont des CODES appliqués par le thème (source unique :
     data-tiers de #onix-promo-suggest, snippets/cart-drawer.liquid). La page est
     autonome ({% layout none %}) : ce bloc et son script n'existent pas ici — sans
     cette pose, le prix plein reste au panier et la promesse de la page n'est pas
     tenue (mesuré 25/10 09h09 : 2 maillots = 49,98 € au lieu de 42,48 €). Même
     mécanique que le thème (setSessionDiscount de cart-drawer-promo-suggest.js) :
     effacer la remise de session puis naviguer vers /discount/CODE — un code de
     session a un seul propriétaire par page ; ici, c'est nous.
     ⚠️ Deux fichiers portent cette table : cart-drawer.liquid (le thème) et
        onboarding-panier.js (cette page) — à changer ensemble.
     25/10 09h52 : le client a CLIQUÉ l'offre du palier promis par la page : un
        code de PALIER posé avant (même table) se REMPLACE — le thème fait
        pareil (findOurAppliedTier : un code de session est remplaçable plutôt
        que de laisser le client payer plus). Une remise HORS table (roue,
        popup newsletter, bundle) prime : on ne touche pas (wheelCodeActive).
        Mesuré 09h50 : le garde « ne touche jamais » laissait onix3 (−15 %)
        sur un panier de 4 maillots : 84,97 € au lieu de 74,97 €. */
  const PALIERS = [
    { qty: 2, code: 'onix3' },
    { qty: 3, code: 'onix4' },
    { qty: 4, code: 'onixtoast' },
    { qty: 5, code: 'onixgift' },
    { qty: 9, code: 'onixfree' },
  ];

  async function posePalierPuisCart() {
    try {
      const c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const n = (c.items || []).reduce((t, i) =>
        (i.properties && i.properties._offer_bundle === 'true') ? t : t + i.quantity, 0);
      let code = null;
      for (const p of PALIERS) if (n >= p.qty) code = p.code;
      const tenus = [];
      for (const a of (c.cart_level_discount_applications || [])) if (a.title) tenus.push(String(a.title).toUpperCase());
      for (const i of (c.items || [])) {
        for (const d of (i.discounts || [])) if (d.title) tenus.push(String(d.title).toUpperCase());
      }
      for (const d of (c.discount_codes || [])) if (d.code) tenus.push(String(d.code).toUpperCase());
      const horsPalier = tenus.filter((t) => !PALIERS.some((p) => p.code.toUpperCase() === t));
      if (code && horsPalier.length === 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'discount='
        });
        await fetch('/discount/' + encodeURIComponent(code));
      }
    } catch (e) { /* sans code posé, le panier reste juste : aucun blocage */ }
    /* Destination : la page /cart du site est un passe-plat (sections/cart.liquid :
       elle renvoie au referrer en posant onixOpenCart=1, et le tiroir s'ouvre à
       l'arrivée — cart-drawer.js:160). La page onboarding n'a pas de tiroir
       ({% layout none %}) : on pose le marqueur nous-mêmes — même sémantique que
       le passe-plat — et on envoie à l'accueil : le client voit son panier
       s'ouvrir avec le code de palier appliqué. Mesuré 09h30 : /cart ramène à la
       page d'où on vient, le client resterait piégé sur l'onboarding rechargée. */
    try { window.sessionStorage.setItem('onixOpenCart', '1'); } catch (e) {}
    window.location.assign('/');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancheClics);
  else brancheClics();
})();
